import styled from 'styled-components';

import { getThemeColor } from '@utils/styled';

import Typography from '@common/components/Typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WorkloadPercentage = styled(Typography).attrs({
  variant: 'body2',
})`
  margin-bottom: 0;
  color: ${getThemeColor('bluegrey.60')};
  font-weight: 500;
`;

export const Title = styled(Typography).attrs({
  variant: 'h6',
})`
  margin-bottom: 0;
  color: ${getThemeColor('grey.0')};
  line-height: 1.2;
`;

export const PlaceNameAddition = styled(Typography).attrs({
  variant: 'body2',
})`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'equal', 15)}
`;

export const Section = styled.div`
  ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'equal', 3)}

  &:first-child {
    ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'equal', 4)}
    ${({ theme }) => theme.getFluidSpacing('padding-top', 'equal', 3)}
  }
`;

export const DividedSection = styled(Section)`
  border-top: 1px solid ${getThemeColor('bluegrey.80')};
  ${({ theme }) => theme.getFluidSpacing('padding-top', 'equal', 3)}
  ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'equal', 3)}

  &:first-child {
    border-top: 0;
  }
`;

export const SectionValue = styled(Typography).attrs({
  variant: 'paragraph1',
})`
  margin-bottom: 0 !important;
  color: ${getThemeColor('grey.0')};
  font-weight: 500;
`;

export const SectionTitle = styled(Typography).attrs({
  variant: 'body2',
})`
  margin-bottom: 0;
  color: ${getThemeColor('bluegrey.60')};
  font-weight: 500;
`;

export const SectionSecondaryValue = styled(Typography).attrs({
  variant: 'body1',
})`
  color: ${getThemeColor('bluegrey.60')};

  &:last-child {
    margin-bottom: 0;
  }

  &:not(:last-child) {
    ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'equal', 4)}
  }
`;

export const ButtonContainer = styled.div`
  margin-top: auto;
`;
